import { createSlice } from '@reduxjs/toolkit'
import { URLParams } from './app-url-params-types'

const INITIAL_STATE = {} as URLParams

const urlParamsSlice = createSlice({
  name: 'urlParams',
  initialState: INITIAL_STATE,
  reducers: {},
})

export default urlParamsSlice
